import axios from 'axios';
import store from '@/store/index';
import md5 from 'js-md5';
import { getToken, getMessageByCode } from './utils';
import bus from '@/utils/mitt.js';
const isPrd = process.env.NODE_ENV === 'prd';
const baseURL = '/';
// 储存请求标识
const pending = [];
const pendingRequest = new Map();
const {
  CancelToken
} = axios;
const clientConfig = {
  timeout: 60000,
  withCredentials: true,
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
};
export class Http {
  constructor(defaultConfig = {}) {
    this.defaultConfig = {};
    this.defaultConfig = defaultConfig || {};
    this.init();
    this.interceptors();
  }
  init() {
    this.$axiosInstances = axios.create({
      ...this.defaultConfig
    });
  }
  getErrorMessage(error) {
    let message = error.message;
    switch (error.code) {
      case 'ERR_NETWORK':
        message = '网络错误';
        break;
      case 'ETIMEDOUT':
        message = '请求超时';
        break;
      case 'ERR_BAD_REQUEST':
        switch (error.response.status) {
          case 400:
            message = '很抱歉，出现了一些技术问题，请稍后重试。';
            break;
          case 401:
            store.dispatch('userInfo/Logout');
            message = '用户未登录，请先登录后再进行操作。';
            break;
          case 402:
            message = '很抱歉，您目前没有体验资格/体验次数已用尽，无法进行相关操作。';
            break;
        }
        break;
      default:
        message = '网络异常';
        break;
    }
    bus.emit('flvEnd', true);
    ElMessage({
      type: 'error',
      showClose: true,
      duration: 5000,
      message: message
    });
  }
  interceptors() {
    this.$axiosInstances.interceptors.request.use(config => {
      config.headers.Authorization = getToken();
      // this.removePending(config)
      // config.cancelToken = new CancelToken((cancel) => {
      //   const tag = this.hashTag(config)
      //   pending.push({
      //     tag,
      //     fn: cancel,
      //   })
      // })
      this.removePendingRequest(config);
      this.addPendingRequest(config);
      return config;
    }, error => {
      this.clearPending();
      console.log('request_use_error', error);
      return Promise.reject(error);
    });
    this.$axiosInstances.interceptors.response.use(response => {
      var _response$data;
      // this.removePending(response.config) //请求结束删除对应的
      this.removePendingRequest(response.config);
      const code = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code; // 根据errorCode，对业务做异常处理(和后端约定)
      // console.log('response', response, response.data)
      return Promise.resolve(response);
    }, error => {
      // 处理status非200
      console.log('response_use_error', error, error.response, axios.isCancel(error));
      if (axios.isCancel(error)) return false;
      this.getErrorMessage(error);
      return Promise.reject(error.message);
    });
  }
  /**
   * @desc  根据请求的url和method生成hash标识
   * @param {String} url
   * @param {String} method
   */
  hashTag(config) {
    return md5(`${config.url}${config.method}`);
  }
  // 在路由跳转时调用
  generateReqKey(config) {
    const {
      method,
      url,
      params,
      data
    } = config;
    return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&');
  }
  /**
   * @desc  取消未响应的重复请求, 并从记录中移除对应的hash标识
   * @param {Object} config
   */
  removePending(config) {
    const currentTag = this.hashTag(config);
    pending.forEach((item, index) => {
      const {
        tag,
        fn
      } = item;
      if (currentTag === tag) {
        fn && fn();
        pending.splice(index, 1);
      }
    });
  }
  addPendingRequest(config) {
    const requestKey = this.generateReqKey(config);
    config.cancelToken = config.cancelToken || new CancelToken(cancel => {
      if (!pendingRequest.has(requestKey)) {
        pendingRequest.set(requestKey, cancel);
      }
    });
  }
  removePendingRequest(config) {
    const requestKey = this.generateReqKey(config);
    if (pendingRequest.has(requestKey)) {
      const cancelToken = pendingRequest.get(requestKey);
      cancelToken(requestKey);
      pendingRequest.delete(requestKey);
    }
  }
  clearPending() {
    for (const [requestKey, cancelToken] of pendingRequest) {
      cancelToken(requestKey);
    }
    pendingRequest.clear();
  }
  async request(query) {
    const {
      method,
      url,
      params = {},
      config = {},
      returnAll = false,
      errorMessageAlert = true
    } = query;
    const paramsObj = ['get'].includes(method) ? {
      params
    } : {
      data: params
    };
    // eslint-disable-next-line no-async-promise-executor
    const promise = new Promise(async (resolve, reject) => {
      try {
        const res = await this.$axiosInstances({
          method,
          url,
          ...paramsObj,
          ...config
        });
        if (res) {
          if (res.data.code != 200) {
            if (returnAll) {
              return resolve(res.data);
            }
            errorMessageAlert && getMessageByCode(res.data.code, (res === null || res === void 0 ? void 0 : res.data.message) || (res === null || res === void 0 ? void 0 : res.data.msg));
            reject(res);
          } else {
            if (returnAll) {
              resolve(res.data);
            } else {
              resolve(res.data.data);
            }
          }
        }
      } catch (error) {
        console.log('request_error', error);
        reject(error);
      }
    });
    return promise;
  }
  get(query) {
    return this.request({
      ...query,
      method: 'GET'
    });
  }
  post(query) {
    return this.request({
      ...query,
      method: 'POST'
    });
  }
  put(query) {
    return this.request({
      ...query,
      method: 'PUT'
    });
  }
  delete(query) {
    return this.request({
      ...query,
      method: 'DELETE'
    });
  }
  patch(query) {
    return this.request({
      ...query,
      method: 'PATCH'
    });
  }
  upload(query, progressCallback) {
    let start = new Date();
    return this.request({
      ...query,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 0,
        onUploadProgress: progressEvent => {
          if (!progressCallback) return;
          const loaded = progressEvent.loaded;
          const total = progressEvent.total;
          // 计算上传速度和预计时间
          const seconds = (new Date().getTime() - start.getTime()) / 1000;
          const curUpMb = progressEvent.bytes / 1024 / 1024;
          const speed = (curUpMb / seconds).toFixed(2);
          start = new Date();
          progressCallback({
            speed: parseFloat(speed),
            progress: progressEvent.progress * 100,
            timeRemaining: speed && parseFloat(((total - loaded) / 1024 / 1024 / speed).toFixed(2)) //剩余时间 S
          });
        }
      },

      method: 'POST'
    });
  }
}
export default new Http(clientConfig);